import DataTable from "../../../components/data-table/data-table";
import { alertcaseColumns } from "../alertcases-columns";

interface IAlertCasesProps {
  onActionClick?: (action_key: string, rowId: string) => void;
  onBeforeRowClick?: (rowId: string) => Promise<boolean>;
}

const FinishedAlertCases = ({onActionClick, onBeforeRowClick}: IAlertCasesProps) => {
  return <div className="finishedAlertCases">
    <DataTable
      style="compact"
      columns={alertcaseColumns}
      defaultSortDirection="desc"
      defaultSortCol="creation_date"
      dataUrl={{
        url: "alertcases",
        backend: "manager",
        queryString: "finished=True"
      }}
      selectionMode="off"
      onActionClick={onActionClick}
      onBeforeRowClick={onBeforeRowClick}
    />
  </div>;
};

export default FinishedAlertCases;